import type { LeadFormFields } from './lead-form.interface';

export const LeadFormDefaults: {
  fields: { [Key in keyof LeadFormFields]: string };
} = {
  fields: {
    TitleLabel: 'Aanhef',
    TitleRequiredError: 'Aanhef is verplicht',
    InitialsLabel: 'Voorletters',
    InitialsRequiredError: 'Voorletters zijn verplicht',
    InsertionsLabel: 'Tussenvoegsel',
    LastNameLabel: 'Achternaam',
    LastNameRequiredError: 'Achternaam is verplicht',
    EmailLabel: 'E-mail',
    EmailRequiredError: 'E-mail is verplicht',
    EmailInvalidError: 'E-mail moet valide zijn',
    PhoneLabel: 'Telefoonnummer',
    PhoneInvalidError: 'Telefoonnummer is verplicht',
    PhoneRequiredError: 'Telefoonnummer moet valide zijn',
  },
};
